import { combineReducers } from 'redux';
import activityReducer from './activity/reducer';

export default combineReducers({
    activitiesArray: activityReducer
});
